import FreeHotel from './FreeHotel';

export default FreeHotel;
